import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { Product } from '../../../core/models/product'
import { GRID_VIEW, LIST_VIEW, ThemeConfig } from '../../../core/helpers/theme-config';
import { AddCartEvent, CartProduct } from '../../../cart/models/cart-models';
import { FavoriteProduct, ToggleFavoriteEvent } from '../../../catalog/models/favorite-product';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { Setting } from '../../../core/models/setting';
import { CombinedFacets } from '../../../facets/models/facet';

const gridTileSizeXXL = ThemeConfig.get<number>('catalog', 'grid-tile-size-xxl')
const gridTileSizeXL = ThemeConfig.get<number>('catalog', 'grid-tile-size-xl')
const gridTileSizeLG = ThemeConfig.get<number>('catalog', 'grid-tile-size-lg')
const gridTileSizeMD = ThemeConfig.get<number>('catalog', 'grid-tile-size-md')
const gridTileSizeSM = ThemeConfig.get<number>('catalog', 'grid-tile-size-sm')

const gridTileSizeXXLFullwidth = ThemeConfig.get<number>('catalog', 'grid-tile-size-xxl-fullwidth')
const gridTileSizeXLFullwidth = ThemeConfig.get<number>('catalog', 'grid-tile-size-xl-fullwidth')
const gridTileSizeLGFullwidth = ThemeConfig.get<number>('catalog', 'grid-tile-size-lg-fullwidth')
const gridTileSizeMDFullwidth = ThemeConfig.get<number>('catalog', 'grid-tile-size-md-fullwidth')
const gridTileSizeSMFullwidth = ThemeConfig.get<number>('catalog', 'grid-tile-size-sm-fullwidth')

const gridClasses = [
  `col-xxl-${gridTileSizeXXL}`,
  `col-xl-${gridTileSizeXL}`,
  `col-lg-${gridTileSizeLG}`,
  `col-md-${gridTileSizeMD}`,
  `col-sm-${gridTileSizeSM}`
]

const gridClassesFullWidth = [
  `col-xxl-${gridTileSizeXXLFullwidth}`,
  `col-xl-${gridTileSizeXLFullwidth}`,
  `col-lg-${gridTileSizeLGFullwidth}`,
  `col-md-${gridTileSizeMDFullwidth}`,
  `col-sm-${gridTileSizeSMFullwidth}`
]

@Component({
  selector: 'app-products',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsComponent {
  @Input() products: Product[]
  @Input() cartProducts: {[product: string]: CartProduct}
  @Input() favoritesProducts: FavoriteProduct[]
  @Input() combinedFacets: CombinedFacets
  @Input() loading: boolean
  @Input() loaded = false
  @Input() viewType: string
  @Input() catalogItemPageSettings: Setting
  @Input() quantityPicker: string
  @Input() allowOutOfStockOrdering: boolean

  @Output() onDetails = new EventEmitter<Product>()
  @Output() onFavoriteToggle = new EventEmitter<ToggleFavoriteEvent>()
  @Output() onAddCart = new EventEmitter<AddCartEvent>()
  fullWidthView$: Observable<boolean>

  constructor(private store: Store<any>) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  get gridViewType(): string {
    return GRID_VIEW
  }

  get listViewType(): string {
    return LIST_VIEW
  }

  get groupedProductsListType(): string {
    return 'grouped-products-view'
  }

  loaderItemsCount(fullWidth = false): number {
    return 12 / (fullWidth ? gridTileSizeXXLFullwidth : gridTileSizeXXL)
  }

  gridClasses(fullWidth = false): string[] {
    return fullWidth ? gridClassesFullWidth : gridClasses
  }

  get hasProducts(): boolean {
    return this.products && !!this.products.length
  }

  cartProduct(product: Product): CartProduct {
    return this.cartProducts[product._id]
  }

  openDetails(product: Product) {
    this.onDetails.emit(product)
  }

  isFavorite(product): boolean {
    if(product && this.favoritesProducts)
      return !!this.favoritesProducts.find(item => product.code === item.productCode)
    return false
  }

  toggleFavorite(e: ToggleFavoriteEvent) {
    this.onFavoriteToggle.emit(e)
  }

  addCart(event: AddCartEvent) {
    this.onAddCart.emit(event)
  }

}
